import React, { Component } from 'react'
import styled from 'styled-components'
import Button from './../buttons/buttons.component'
import Captcha from './../captcha/captcha.component'
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux'
import { EmailInput } from './../form-components/inputs.component'
import { breakpoints } from '../../constants/breakpoints.constants'
import { UserService } from '../../services/user.service'
import { Form, Formik } from 'formik'
import { toastActions } from '../../actions'
import { BLUE, BACKGROUND, PRIMARY_COLOR } from '../../styles/colors.style'
import * as Yup from 'yup'

const dashLength = 40
const gap = 7

const StyledDashed = styled.div`
	background: repeating-linear-gradient(
		140deg,
		${PRIMARY_COLOR},
		${PRIMARY_COLOR} ${dashLength}px,
		transparent ${dashLength}px,
		transparent ${dashLength + gap}px,
		${BACKGROUND} ${dashLength + gap}px,
		${BACKGROUND} ${dashLength * 2 + gap}px,
		transparent ${dashLength * 2 + gap}px,
		transparent ${dashLength * 2 + gap * 2}px,
		${BLUE} ${dashLength * 2 + gap * 2}px,
		${BLUE} ${dashLength * 3 + gap * 2}px,
		transparent ${dashLength * 3 + gap * 2}px,
		transparent ${dashLength * 3 + gap * 3}px
	);
	width: 100%;
	height: 10px;
`

const StyledContainer = styled.div`
	background-color: #f8f9fb;
	height: 242px;
	width: 100%;
	@media screen and (max-width: 635px) {
		height: 300px;
	}
`

const schema = Yup.object().shape({
	email: Yup.string()
		.email('Por favor, informe um endereço de email válido.')
		.required('Informe um e-mail!')
})

const StyledFormContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 80%;
	.form {
		display: flex;
		position: relative;
		.button {
			margin-left: 25px;
		}
		input[type='email'] {
			height: 57px;
		}

		@media screen and (max-width: 635px) {
			flex-direction: column;
			width: 100%;
			.button {
				margin-left: 0;
				margin-top: 30px;
				width: 100%;
				z-index: 1;
			}

			.email {
				margin-top: 40px;
			}

			.error {
				width: 100%;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) and (orientation: landscape) {
			.button {
				width: auto;
			}
		}
	}
`

const StyledBody = styled.div`
	align-items: center;
	display: flex;
	height: 100%;
	justify-content: center;

	@media screen and (max-width: 635px) {
		flex-direction: column;
	}
`

const StyledSubscriptionSpan = styled.span`
	align-items: flex-end;
	display: flex;
	font-size: 3rem;
	justify-content: center;
	width: 33%;
	z-index: 1;

	@media screen and (max-width: 635px) {
		width: 100%;
	}
`

const StyledSmileSpan = styled.span`
	color: ${PRIMARY_COLOR};
	margin-left: 10px;
`

const StyledEnvelopeContainer = styled.div`
	color: rgba(81, 122, 188, 0.2);
	position: absolute;
`

const Envelope = props => {
	return (
		<StyledEnvelopeContainer style={{ left: props.left, top: props.top }}>
			<FontAwesome
				name={'envelope-o'}
				style={{ fontSize: props.size + 'rem' }}
			/>
		</StyledEnvelopeContainer>
	)
}

const BUTTON = {
	DEFAULT: () => <span>Receber novidades</span>,
	ENVIANDO: () => <span>Enviando...</span>
}

async function handleSubmit() {
	const { values, actions } = this.state
	this.captcha.reset()
	this.setState(
		{
			buttonText: BUTTON.ENVIANDO
		},
		() => {
			const defaultErrorMessage =
				'Não foi possível efetuar o cadastro, por favor tente novamente mais tarde'
			UserService.registerPreUser(values.email)
				.then(({ success, errors }) => {
					if (success) {
						actions.resetForm()
						this.props.success('E-mail cadastrado com sucesso')
					} else if (errors && errors.length) {
						this.props.warning(errors[0])
					} else {
						this.props.danger(defaultErrorMessage)
					}
					this.setState({
						buttonText: BUTTON.DEFAULT
					})
				})
				.catch(() => {
					this.props.danger(defaultErrorMessage)
					this.setState({
						buttonText: BUTTON.DEFAULT
					})
				})
		}
	)
}

function captchaOnChange(value) {
	if (this.state.isSubmitting && value) handleSubmit.call(this)
}

function validateCaptcha(values, actions) {
	this.setState({ isSubmitting: true, values, actions })
	this.captcha.execute()
}

class SubscribeForNewsComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			actions: null,
			isSubmitting: false,
			values: null,
			buttonText: BUTTON.DEFAULT
		}
	}

	render() {
		const { buttonText } = this.state
		return (
			<StyledContainer>
				<Captcha
					onChange={captchaOnChange.bind(this)}
					style={{ position: 'absolute', top: '50%' }}
					ref={el => {
						this.captcha = el
					}}
				/>
				<StyledDashed />
				<StyledBody>
					<StyledSubscriptionSpan>
						<span className="blue">
							<span className="bold">Cadastre-se</span> para
							<br />
							<br />
							receber <span className="bold">novidades</span>{' '}
						</span>
						<StyledSmileSpan>;-)</StyledSmileSpan>
					</StyledSubscriptionSpan>
					<StyledFormContainer>
						<Formik
							initialValues={{
								email: ''
							}}
							onSubmit={validateCaptcha.bind(this)}
							validationSchema={schema}
							render={props => (
								<Form className="form" noValidate>
									<EmailInput
										shadow
										noBorder
										id="email"
										placeholder={
											window.innerWidth >= 321
												? 'Seu e-mail...'
												: 'Seu e-mail'
										}
										icon={() => (
											<FontAwesome
												className="icon"
												name="envelope-o"
												size="3x"
											/>
										)}
										style={{ background: 'white' }}
										className={'email'}
										{...props}
									/>
									<Button
										shadow
										primary
										className="button"
										type="submit">
										{buttonText()}
									</Button>
									<Envelope size={12} top={-53} left={-27} />
									<Envelope size={3.5} top={-45} left={168} />
									<Envelope size={5} top={50} left={100} />
								</Form>
							)}
						/>
					</StyledFormContainer>
				</StyledBody>
			</StyledContainer>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return {
		danger: message => dispatch(toastActions.danger({ message })),
		success: message => dispatch(toastActions.success({ message })),
		warning: message => dispatch(toastActions.warning({ message }))
	}
}

const connectedComponent = connect(
	null,
	mapDispatchToProps
)(SubscribeForNewsComponent)

export { connectedComponent as SubscribeForNews }
